import getLanguageByPath from '@src/utils/locale/getLanguageByPath.js';
import mergeLocalesData from '@src/global-locales/utils/merge-locales-data.js';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName.js';

const languageFilePath = getLanguageByPath() === 'zh-cn' ? '' : `${getLanguageFolderName()}/`;

/**
 * @name pageLocalesData
 */
const pageLocalesData = {
  global: {
    comming_soon: '敬请期待',
    copiedGoToMobileToOpen: '已复制链接，请前往移动端打开'
  },
  // 通用
  common: {
    login_content: '登录',
    preRegister_login_content: '预约',
    exit_content: '退出'
  },
  cookie: {
    tips: 'The website uses cookies to enhance your browsing experience. <a href="{link}" target="_blank" >Learn more</a>',
    button: 'ok'
  },
  cookieInfo: {
    perference_settings: 'Perference Settings',
    cookie_description:
      'We use necessary cookies to ensure our website functions properly. Additionally, we also wish to employ optional cookies (including those from third-party partners) to enhance your experience and analyze site usage. For more details, please refer to our<a href="{link}" target="_blank" >Cookie Policy</a>.',
    settings_description:
      'Cookies and similar technologies may be used to store or retrieve information during your visit. While cookies are necessary for basic site functions, you can choose to disable certain types. Note that this may impact your experience.',
    necessary_cookies: 'Necessary Cookies',
    necessary_cookies_description: 'Necessary for enabling basic website functionalities, you cannot disable necessary cookies.',
    analytics_cookies: 'Analytics Cookies',
    analytics_cookies_description: '帮助网站运营商了解其网站的运行情况、访问者如何与网站互动以及是否可能存在技术问题。',
    view_details: ' View Details',
    _ga_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_duration: '1年',
    _ga_x_description: '生成有关访客如何使用我们的服务的统计数据',
    _ga_x_duration: '1年',
    _gid_description: '生成有关访客如何使用我们的服务的统计数据',
    _gid_duration: '1天',
    session_id_description: '保存用户登录状态相关信息',
    session_id_duration: '3小时（有访问会续期）',
    cookie_flag_description: '用于保存用户cookie设置状态',
    cookie_flag_duration: '90天',
    label_name: '名称',
    label_provider: '提供者',
    label_duration: '持续时间',
    label_description: '说明',
    confirm_btn: 'Confirm',
    allow_all_btn: 'allowAll',
    cookie_setting_btn: 'cookie设置',
    reject_all_cookies: '拒绝所有的cookies',
    allow_all_cookies: '接受所有的cookie'
  },
  navbar: {
    home: '首页',
    news: '新闻资讯',
    games_introduction: '游戏介绍',
    game_play: '游戏玩法',
    mecha: '机兵介绍',
    combat_information: '作战资料',
    msmk_raiders: '玛什马克攻略战',
    map3v3: '3V3地图',
    map: '6V6地图',
    world_view: '世界观',
    FAQ: 'FAQ',
    activity_zone: '活动专区',
    creator_progam: '创作者活动',
    twitch_drop: 'TwitchDrop',
    pack_center: '礼包中心',
    collectors_pack: '特装机典藏版',
    premium_games: '精品游戏',
    more_game: '更多游戏',
    official_tool: '官方工具',
    customer_service: '用户服务',
    know_us: '了解我们',
    join_us: '加入我们',
    listOfAppearances: '造型排行榜',
    callCenter: '客服中心',
    pioneerTeamActivity: '先驱小队活动',
    download: '下载游戏'
  },
  common_footer: {
    privacy_policy: '隐私政策',
    terms_of_service: '服务条款',
    all_rights: 'SEASUN GAMES PTE. LTD. All rights reserved.',
    cookie_agreement: 'cookie协议',
    cookie_setting: 'cookie设定',
    privacy_agreement: '隐私权政策',
    right_of_useAgreement: '使用权协议',
    official_tool: '官方工具',
    game_launcher: '启动器',
    customer_service: '用户服务',
    personal_center: '个人中心',
    reCharge_center: '充值中心',
    know_us: '了解我们',
    about_seasun: '关于西山居',
    followUs: '关注我们',
    community: 'Community: contact@seasungames.com',
    support_partner: 'Support & Partnership: bd@seasungames.com',
    join_us: '加入我们',
    careers: '招聘官网',
    corporation: '成都西山居世游科技有限公司 版权所有',
    copyright_btn: '版权信息',
    purchase: '',
    funds_ja: '',
    acquisition_ja: '',
    zh_text: ''
  },
  // 预约
  reserve: {
    button: '立即预约',
    gift_button: '预约有礼',
    success: {
      title: '已注册',
      tips: 'Follow us for more updates',
      btnConfirm: '确定'
    },
    form: {
      phone: '手机号',
      email: '邮箱',
      vcode: '验证码',
      get_code: '[获取验证码]',
      resend: '重新发送'
    },
    logic: {
      need_agreement: '请先勾选同意隐私条款',
      need_email: '请输入邮箱账号',
      need_phone: '请输入手机号',
      need_vcode: '请输入验证码',
      has_success: '已预约成功',
      auto_close: '{second}（s）后自动关闭',
      phone_format: '请输入正确的手机号码',
      email_format: '请输入正确的邮箱',
      vcode_countdown: '{countdown}（s）后重试'
    },
    agreement: {
      agreement1: '《西山居用户协议》',
      agreementLink1: 'www.baidu.com',
      agreement2: '《西山居用户个人用户信息及隐私保护政策》',
      agreementLink2: 'www.baidu.com',
      desc: '我已阅读并同意<a t href="//{arg1Link}" target="_blank">{arg1}<a/><a href="//{arg2Link}" target="_blank">{arg2}<a/>'
    }
  },
  // 礼包领取弹窗
  gift: {
    cdkCode_modal_title: '领取礼包码',
    copy_btn_text: '复制',
    pickUp_location_tips_text: '请前往游戏内XXX处输入礼包兑换码进行兑换',
    claim_limit_tips_text: '*每位用户仅限兑换一次',
    claim_rewards_btn_text: '领取奖励',
    copy_success_tips_text: '复制成功',
    copy_error_tips_text: '拷贝失败'
  },

  // 首页
  main: {
    kvScreen: {
      downloadText: '下载游戏',
      appointmentText: '预约游戏',
      steamWishBtnText: '添加到Steam愿望单',
      xboxWishBtnText: '添加到Xbox愿望单',
      preRegisterTips: '您已预约'
    },
    wordScreen: {
      nextText: 'Next'
    }
  },

  // 特装详情
  mechaUnit: {
    voiceTabCH: '中文',
    voiceTabEN: '英语',
    voiceTabJA: '日语',
    basicInfoTitle: '基础信息',
    roleExperSubTitle: '角色经历',
    driverVoiceTitle: '驾驶员语音',
    mechaStorySubTitle: '机体背景',
    falcon: {
      driverName: '莱奥妮·菲尔',
      driverType: '矛隼特装型驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：希古尼亚联合体 赫罗兰王国',
      driversStructure: '搭乘机体：矛隼特装型',
      driversRoleExperText:
        '在媒体的聚光灯下，莱奥妮·菲尔始终有着不少头衔：联合体的首批人造奇迹之子，皇家飞行大队的驾驶员，更是今天的环海能源的年轻董事长。但鲜有人知的是她的另一个身份——S.H.A.D.O.W.行动队的矛隼驾驶员。也许从父亲死于意外的那刻开始，莱奥妮命运的齿轮就已经拨动了：她放弃学业亲历边境地区，冲破来自集团内的重重干预追查父亲的遇害真相，一度濒临危情却为边境路网搭救，在与这一众人的相处中，她逐渐理解认同了父亲所追求的济世理念。在边境路网的相助下，莱奥妮以身设局成功夺回一切，揪出内鬼，粉碎了他们企图扭曲整个集团的阴谋。如今的莱奥妮早已习惯了董事长与驾驶员的身份切换：驾驶矛隼时的她毫无身份包袱，履行小队的行动方针，完美担当着侦察与掠袭的前锋角色......也许这种切身的行动力才是她内在之所以强大的由来。',
      mechaInfoType: '矛隼 特装型',
      mechaInfoNums: '机体编号：UBP-R02C',
      mechaInfoHeadHigh: '头顶高：14.7米',
      mechaInfoEmptyWeight: '空重：13.8吨',
      mechaInfoTotal: '全重：16.1吨',
      mechaInfoStory:
        '这台机兵是“瓦尔文”项目引入意识投影技术后生产的第六台原型机，被用作联合体各类新型传感器的测试平台，态势感知能力显著优于其他原型机。参与测试的军方人士建议基于该机开发专用侦察型号，备受喜爱的“矛隼”应运而生——它的进攻性武装少于标准型号，但配备了更加优秀的级联引擎和传感器。“矛隼”顺利量产后该机功成身退，被橡树生命的脑科学研究部门购得，用于探索意识投影技术的性能边界。据说该机在某次例行测试中遭遇EIC灾害并失联，疑似已被EIC侵蚀控制，沦落为“幽灵机兵”的一员。直到数年后，这台机体随S.H.A.D.O.W.行动队高调亮相，相关人士才恍然明白当年对外宣称的“意外”大有门道。',
      manufacturerGruopCh: '比弗罗斯特工业集团',
      cvCH: '黄莺',
      cvEN: 'Ali  Hillis',
      cvJA: '小清水亚美',
      voice: {
        title1: '莱奥妮·菲尔！矛隼驾驶员，很高兴认识你，祝我们合作愉快！',
        title2: '该我和矛隼上阵了么。',
        title3: '胜利之光与矛隼共舞！'
      }
    },
    feijing: {
      driverName: '014',
      driverType: '飞景改装型驾驶员',
      driversSex: '性别：男',
      driversBirthplace: '出生地：罗迦共和国',
      driversStructure: '搭乘机体：飞景改装型',
      driversRoleExperText:
        '014这个编号是他的名字，作为战争机器诞生于培养舱，时任风标航运高层的父亲阿德里安还给了他另外的名字“陆回”。阿德里安的孩子陆回，从一出生就被训练成绝对忠诚于风标航运的战斗者，好在母亲的陪伴使得他黑暗的童年有了光亮。母亲不知去了哪里，成年后他奉阿德里安之命潜入薪火重工盗取“飞景”机兵数据时，一直在寻找母亲的下落。然而在薪火重工，他没料到会遇见众多战友，教会了战争机器何为战友的温度。陆回从阿德里安的掌控中叛逃。在风标航运，阿德里安的“女王蜂”计划正在进行。“女王蜂”连接着杀戮机器，那就是陆回的克隆人们，014是其中之一。014为父亲执行任务，以为自己是陆回，当他发现真相、当陆回把“飞景”交给他时，钢铁羽翼下他明白了存在的意义。014与陆回联手摧毁“女王蜂”，沉重打击风标航运和阿德里安的阴谋，也终于让母亲解脱。',
      mechaInfoType: '飞景 改装型',
      mechaInfoNums: '机体编号：PGI-T27G3',
      mechaInfoHeadHigh: '头顶高：16.6 米',
      mechaInfoEmptyWeight: '空重：17.2 吨',
      mechaInfoTotal: '全重：23.3 吨',
      mechaInfoStory: '占位，目前文案没定',
      manufacturerGruopCh: '薪火重工',
      cvCH: '马洋',
      cvEN: 'Griffin Puatu',
      cvJA: '千叶翔也',
      voice: {
        title1: '014，战前准备完成，随时出发。',
        title2: ' 014报道，你可以称我陆回。',
        title3: '感受到杀机了么，飞景在靠近。'
      }
    },
    baihong: {
      driverName: '吉娜',
      driverType: '白虹特装型驾驶员',
      driversSex: '性别：女',
      driversBirthplace: '出生地：月海共同体',
      driversStructure: '搭乘机体：白虹特装型',
      driversRoleExperText:
        '吉娜是月球地球最有人气的歌星，也是背负血仇的机甲战士。吉娜的歌声曾抚慰过无数移民月球却生活在底层的“后来者”，而现在她驾驶着"白虹"正穿梭于弹火之中。年少时与父亲哥哥分开，和母亲在月面大都市生活，18岁横跨地月成为超级巨星时，却不知父亲凯恩早已暗中领导着月球底层反抗组织"特伊亚"。命运的转折始于一场巡演，当她在反抗军基地与父亲重逢，目睹人们的艰辛与困苦，目睹父亲向贫民窟鞠躬，吉娜的音乐开始染上抗争的血色。太空电梯落成典礼本该是她又一次艺术巅峰，崩塌的太空电梯碎片却夺去了数十万生命，袭击者竟是高喊着"革命需要牺牲"的亲哥哥。父亲倒在哥哥的枪响下，昔日温柔的兄长已成恶魔，操控着更名"特伊亚战线"的武装集团对地月进行暴力打击。而今吉娜成为S.H.A.D.O.W.行动队的一员，“白虹”摧毁阴谋时，驾驶舱里永远循环着那首未完成的安魂曲，紧握操纵杆的吉娜说道："我只想亲眼看着哥哥戴上镣铐。"',
      mechaInfoType: '白虹 特装型',
      mechaInfoNums: '机体编号：MHI-SR00',
      mechaInfoHeadHigh: '头顶高：16.2 米',
      mechaInfoEmptyWeight: '空重：19.9 吨',
      mechaInfoTotal: '全重：22.8 吨',
      mechaInfoStory:
        '这台“白虹”是摩诃重工生产的第一台意识投影型机兵，与“龙渊”同源，均为同盟开发意识投影的技术原型之一。边境战争后期，月海共同体以慷慨的援助诱使兀廷联邦共和国脱离同盟加入月球阵营，借此获得了意识投影技术和这台原型机。月球当局曾试图以该机先进的电子战系统引导卫星炮，一举歼灭月面反抗组织“特伊亚”，却不料该机反被对方俘获，计划也随之泄露。特伊亚受此事刺激行事日益激进，稳健派领袖被迫驾驶本机保护追随者逃离组织。该机加入S.H.A.D.O.W.行动队后，薪火重工扬其所长，为其配备了一架重型炮击无人机，从战场上空降下垂直狙击扫除该机指示的敌人。',
      manufacturerGruopCh: '摩诃重工',
      cvCH: '陶典',
      cvEN: 'TBD',
      cvJA: '内田真礼',
      voice: {
        title1: '吉娜，嗯~是我，唱歌舞蹈我擅长，但是驾驶机兵我还要跟大家好好学习。',
        title2: ' 和你待在一起，我总有很多创作灵感~',
        title3: '我会驾驶白虹歌唱，带给世界希望！'
      }
    }
  }
};

export default mergeLocalesData(pageLocalesData);
